import { render, staticRenderFns } from "./IndicatorOwner.vue?vue&type=template&id=53407810&scoped=true"
import script from "./IndicatorOwner.vue?vue&type=script&lang=js"
export * from "./IndicatorOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53407810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53407810')) {
      api.createRecord('53407810', component.options)
    } else {
      api.reload('53407810', component.options)
    }
    module.hot.accept("./IndicatorOwner.vue?vue&type=template&id=53407810&scoped=true", function () {
      api.rerender('53407810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QspiMasterData/IndicatorOwner.vue"
export default component.exports